import { SMSSenderLayout } from "../SMSSenderLayout";
import { SMSSenderProps } from "../SMSSenderProps";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { SMSSenderEntities } from "../SMSSenderEntities";

interface ProviderListPageProps extends NSARouterMakerResult, SMSSenderProps { }

export default function ProviderListPage(props: ProviderListPageProps)
{
	return (
		<SMSSenderLayout
			{...props}
			action={{
				description: "This section displays all SMS providers you have created with their basic information.",
			}}
			pages={{
				entity: SMSSenderEntities.provider(props),
				list: {
					ui: {}
				}
			}}
		>
			<>
			</>
		</SMSSenderLayout>
	);
}